import { render, staticRenderFns } from "./SandboxRequestDetailComponent.vue?vue&type=template&id=e801612a&scoped=true"
import script from "./SandboxRequestDetailComponent.vue?vue&type=script&lang=js"
export * from "./SandboxRequestDetailComponent.vue?vue&type=script&lang=js"
import style0 from "./SandboxRequestDetailComponent.vue?vue&type=style&index=0&id=e801612a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e801612a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e801612a')) {
      api.createRecord('e801612a', component.options)
    } else {
      api.reload('e801612a', component.options)
    }
    module.hot.accept("./SandboxRequestDetailComponent.vue?vue&type=template&id=e801612a&scoped=true", function () {
      api.rerender('e801612a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/use_cases/components/SandboxRequestDetailComponent.vue"
export default component.exports